export const billingProfileHc = {
  datosFacturacion: {
    titulo: "Dane do faktury",
    requeridos: "Dane do faktury są wymagane",
  },
  perfil: {
    swalTitle: "Proszę sprawdzić pocztę",
    swalText:
      "Aby kontynuować zmianę hasła, proszę sprawdzić skrzynkę odbiorczą i wykonać podane kroki",
    swalConfirm: "Kontynuuj",
    errorInesperado: "Ups! Wystąpił nieoczekiwany błąd",
  },
  facturacionCuenta: {
    editarInfo: "Edytuj informacje",
    direccionLinea1: "Adres, linia 1",
    direccionLinea2: "Adres, linia 2 (opcjonalnie)",
    cancelar: "Anuluj",
    guardando: "Zapisywanie...",
    guardarCambios: "Zapisz zmiany",
    errorCargar: "Błąd podczas wczytywania danych do faktury",
    actualizadoOk: "Dane zostały zaktualizowane",
    errorActualizar: "Błąd aktualizacji",
    errorActualizarDatos: "Błąd podczas aktualizacji danych",
  },
};
